import { getTextNodesContent } from 'app/helpers/string'

/**
 * Alert service for module mwApp.common
 */

/**
 * alertLiteSvc service <br>
 * Show alerts (no confirms)
 *
 * @class alertLiteSvc
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc service
 * @name mwApp/common.service:alertLiteSvc
 */
/* @ngInject */
export function AlertLightSvc ($rootScope, $sce, $q, notifySvc) {
  // for alerts
  $rootScope.closeAlert = function () {
    $rootScope.alertData.displayed = false
  }
  $rootScope.alertData = {
    displayed: false
  }

  $rootScope.notificationIcons = {
    danger: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0833 7.02542L8.98333 0.895943C8.42778 0.368019 7.51667 0.368019 6.98889 0.895943L0.916667 7.02542C0.361111 7.55335 0.361111 8.46471 0.916667 8.98708L7.01667 15.0832C7.54445 15.6389 8.45556 15.6389 8.98333 15.0832L15.0833 8.98708C15.6389 8.45915 15.6389 7.54779 15.0833 7.02542ZM7.21667 5.57479C7.21667 5.14689 7.54445 4.78568 8.00556 4.78568C8.46667 4.78568 8.79445 5.11355 8.79445 5.57479V8.42025C8.79445 8.84815 8.43333 9.20936 8.00556 9.20936C7.57778 9.20936 7.21667 8.84815 7.21667 8.42025V5.57479ZM8.00556 11.7545C7.47778 11.7545 7.06667 11.3155 7.06667 10.8154C7.06667 10.3152 7.47778 9.87621 8.00556 9.87621C8.53333 9.87621 8.94444 10.2874 8.94444 10.8154C8.94444 11.3433 8.50556 11.7545 8.00556 11.7545Z" fill="#E24337"/></svg>\n',
    deleted: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 8C0.5 3.86914 3.83984 0.5 8 0.5C12.1309 0.5 15.5 3.86914 15.5 8C15.5 12.1602 12.1309 15.5 8 15.5C3.83984 15.5 0.5 12.1602 0.5 8ZM5.42187 7.29688C5.01172 7.29688 4.71875 7.61914 4.71875 8C4.71875 8.41016 5.01172 8.70312 5.42187 8.70312L10.5781 8.70313C10.959 8.70313 11.2812 8.41016 11.2812 8C11.2812 7.61914 10.959 7.29688 10.5781 7.29688L5.42187 7.29688Z" fill="#E24337"/></svg>\n',
    error: '<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5581 13.3906L10.2812 1.20312C9.70036 0.265625 8.29964 0.265625 7.75301 1.20312L0.441906 13.3906C-0.104718 14.3281 0.578562 15.5 1.70598 15.5H16.294C17.4214 15.5 18.1047 14.3281 17.5581 13.3906ZM8.19714 5.05357C8.19714 4.6183 8.53878 4.25 9.01708 4.25C9.46121 4.25 9.83702 4.6183 9.83702 5.05357V9.33929C9.83702 9.80804 9.46121 10.1429 9.01708 10.1429C8.60711 10.1429 8.19714 9.80804 8.19714 9.33929V5.05357ZM9.01708 13.3571C8.40213 13.3571 7.92383 12.8884 7.92383 12.3192C7.92383 11.75 8.40213 11.2812 9.01708 11.2812C9.59787 11.2812 10.0762 11.75 10.0762 12.3192C10.0762 12.8884 9.59787 13.3571 9.01708 13.3571Z" fill="#E24337"/></svg>\n',
    info: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0.5C3.83984 0.5 0.5 3.86914 0.5 8C0.5 12.1602 3.83984 15.5 8 15.5C12.1309 15.5 15.5 12.1602 15.5 8C15.5 3.86914 12.1309 0.5 8 0.5ZM8 4.25C8.49805 4.25 8.9375 4.68945 8.9375 5.1875C8.9375 5.71484 8.49805 6.125 8 6.125C7.47266 6.125 7.0625 5.71484 7.0625 5.1875C7.0625 4.68945 7.47266 4.25 8 4.25ZM9.17188 11.75H6.82812C6.41797 11.75 6.125 11.457 6.125 11.0469C6.125 10.666 6.41797 10.3438 6.82812 10.3438H7.29688V8.46875H7.0625C6.65234 8.46875 6.35938 8.17578 6.35938 7.76562C6.35938 7.38477 6.65234 7.0625 7.0625 7.0625H8C8.38086 7.0625 8.70312 7.38477 8.70312 7.76562V10.3438H9.17188C9.55273 10.3438 9.875 10.666 9.875 11.0469C9.875 11.457 9.55273 11.75 9.17188 11.75Z" fill="#E8EAED"/></svg>\n',
    success: '<svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.1739 0.496189C15.6087 0.901805 15.6087 1.61163 15.1739 2.01725L6.61204 10.6704C6.2107 11.1098 5.50836 11.1098 5.10702 10.6704L0.826087 6.34382C0.391304 5.93821 0.391304 5.22838 0.826087 4.82276C1.22742 4.38335 1.92977 4.38335 2.3311 4.82276L5.84281 8.3719L13.6689 0.496189C14.0702 0.0567716 14.7726 0.0567716 15.1739 0.496189Z"/></svg>\n',
    warning: '<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5581 13.3906L10.2812 1.20312C9.70036 0.265625 8.29964 0.265625 7.75301 1.20312L0.441906 13.3906C-0.104718 14.3281 0.578562 15.5 1.70598 15.5H16.294C17.4214 15.5 18.1047 14.3281 17.5581 13.3906ZM8.19714 5.05357C8.19714 4.6183 8.53878 4.25 9.01708 4.25C9.46121 4.25 9.83702 4.6183 9.83702 5.05357V9.33929C9.83702 9.80804 9.46121 10.1429 9.01708 10.1429C8.60711 10.1429 8.19714 9.80804 8.19714 9.33929V5.05357ZM9.01708 13.3571C8.40213 13.3571 7.92383 12.8884 7.92383 12.3192C7.92383 11.75 8.40213 11.2812 9.01708 11.2812C9.59787 11.2812 10.0762 11.75 10.0762 12.3192C10.0762 12.8884 9.59787 13.3571 9.01708 13.3571Z"/></svg>\n'
  }

  $rootScope.loadNotificationIcon = function (key) {
    if (key) {
      return $sce.trustAsHtml($rootScope.notificationIcons[key])
    } else {
      return ''
    }
  }

  // alertLiteSvc object with methods
  const alertLiteSvc = {

    /**
     * Show alert message
     *
     * @memberof mwApp/common.service:alertLiteSvc
     * @param {String} message - message to show
     * @param {String} [type='info']  - message type -> success|info|warning|danger, default = info
     * @param {Number} [timeout=5000] - dismiss timeout, default = 5000ms
     */
    alert: function (message, type, timeout) {
      if (!message) {
        return
      }

      // default timeouts for different message types
      const timeouts = {
        success: 2000,
        deleted: 2000,
        info: 3000,
        warning: 4000,
        danger: 4000,
        error: 4000
      }

      type = type && timeouts[type] ? type : 'info'
      timeout = timeout === undefined ? timeouts[type] : timeout
      message = message
        // .replace(/^"|"$/g, '') // remove boundary quotes, if any. Remove by MW-1754
        .replace(/\\n|\n/g, '<br>') // add line breaks

      $rootScope.alertData.message = $sce.trustAsHtml(message)
      $rootScope.alertData.type4 = type
      $rootScope.alertData.timeout = timeout
      $rootScope.alertData.displayed = true
      $rootScope.alertData.className = type === 'error' ? 'error-message' : ''

      // add any alerted message to notifications
      notifySvc.add(getTextNodesContent(message))
    },

    /**
     * Common callback to use in .catch() block of $http promise
     *
     * @memberof mwApp/common.service:alertLiteSvc
     * @param {Object} rejection
     * @return {Promise}
     */
    alertError: function (rejection) {
      let txt = (rejection === null || rejection === undefined ? ''
        : (typeof rejection === 'object' ? (typeof rejection.data !== 'object' ? String(rejection.data)
          : (rejection.data.message ? String(rejection.data.message) : ''))
          : (typeof rejection === 'string' ? rejection : '')))

      // if <body> present in error rejection
      if (txt.indexOf('<body>') !== -1) {
        // cut <body> content and remove all inner tags
        txt = txt.replace(/^.*<body>(.*)<\/body>.*$/i, '$1').replace(/<[^>]+>/gm, ' ')
      }

      alertLiteSvc.alert(txt, 'error')

      return $q.reject(rejection) // this is vital for bubbling error further, to the next promise, if any
    },

    /**
     * Common callback to use in .success() block of $http promise
     *
     * @memberof mwApp/common.service:alertLiteSvc
     * @param {String} message
     * @param {String} type
     */
    alertSuccess: function (message, type) {
      type = type || 'success'
      return function (response) {
        alertLiteSvc.alert(message, type)
        return response
      }
    }

  }

  return alertLiteSvc
}

/**
 * alertSvc service <br>
 * Show alerts and confirms
 *
 * @class alertSvc
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc service
 * @name mwApp/common.service:alertSvc
 */
/* @ngInject */
export function AlertSvc ($uibModal, $q, alertLiteSvc) {
  // alertSvc object with methods
  return {

    /**
     * Show confirm dialog
     *
     * @memberof mwApp/common.service:alertSvc
     * @param {Object|String} confirmMsg - object { header: '...', text: '...' } or single string
     * @param {Object} options - close modal closing by click on the backdrop
     * @param {String} confirmMsg.header - message header
     * @param {String} confirmMsg.text - message text
     * @return {Promise} promise
     */
    confirm: function (confirmMsg, options = {}) {
      const result = $q.defer()
      $uibModal.open({
        animation: false,
        // scope: modalScope,
        backdropClass: 'modal-top modal-confirmation', // set z-index to 100500
        windowClass: 'modal-top modal-confirmation', // set z-index to 100510
        templateUrl: 'components/common/templates/confirmation.html',
        controller: 'ConfirmDlgCtrl as vm',
        resolve: {
          msg: function () {
            return (typeof confirmMsg === 'string') ? { header: confirmMsg } : confirmMsg
          },
          options: function () {
            return options
          }
        },
        size: 'md',
        backdrop: true
      }).result
        .then(
          function close () {
            result.resolve()
          },
          function dismiss () {
            result.reject()
          }
        )
      return result.promise
    },

    /**
     * Show alert message
     *
     * @memberof mwApp/common.service:alertSvc
     * @param {String} message - message to show
     * @param {String} [type='info']  - message type -> success|info|warning|danger, default = info
     * @param {Number} [timeout=5000] - dismiss timeout, default = 5000ms
     */
    alert: alertLiteSvc.alert,

    /**
     * Common callback to use in .catch() block of $http promise
     *
     * @memberof mwApp/common.service:alertSvc
     * @param {Object} response
     */
    alertError: alertLiteSvc.alertError,

    /**
     * Common callback to use in .success() block of $http promise
     *
     * @memberof mwApp/common.service:alertSvc
     * @param {String} message
     */
    alertSuccess: alertLiteSvc.alertSuccess
  }
}

/**
 * ConfirmDlgCtrl controller
 * Shows confirm modal dialog
 *
 * @class ConfirmDlgCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:ConfirmDlgCtrl
 */
/* @ngInject */
export function ConfirmDlgCtrl ($uibModalInstance, $sce, msg, options) {
  const vm = this

  /**
   * Dialog message
   *
   * @memberof mwApp/common.controller:ConfirmDlgCtrl
   * @type {Object|String}
   */
  vm.msg = msg

  /**
   * Dialog options
   */
  vm.options = options

  if (msg.header) {
    msg.header = $sce.trustAsHtml(msg.header)
  }
  if (msg.text) {
    msg.text = $sce.trustAsHtml(msg.text)
  }

  /**
   * Close modal confirmation dialog by choosing YES | OK
   *
   * @memberof mwApp/common.controller:ConfirmDlgCtrl
   */
  vm.yes = function () {
    $uibModalInstance.close()
  }

  /**
   * Close modal confirmation dialog by choosing NO | CANCEL
   *
   * @memberof mwApp/common.controller:ConfirmDlgCtrl
   */
  vm.no = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
